module.exports = __webpack_public_path__ + "media/mypage/images/collapsible-expanded-be816cf2fefe60852132b927096ed920.png";